import { observer } from 'mobx-react-lite'
import React, { useState, useEffect } from 'react'
import {
  MDBCollapse,
  MDBBtn,
  MDBSelect,
  MDBInput,
  MDBIcon,
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardHeader,
  MDBCardBody,
} from 'mdb-react-ui-kit'
import CustomSwitch from '../../../../components/shared/CustomSwitch/CustomSwitch.component'
import CarrierMgmtStore from './../../CarrierMgmt.store'
import CommissionService from './../../../../shared/services/CommissionLevel.service'
import UserService from '../../../../shared/services/User.service'
import { toast } from 'react-toastify'

import './CarrierContractingConfigForm.scss'

const CarrierContractingConfigForm = ({ table }) => {
  const [uplineOptionsOnboarding, setUplineOptionsOnboarding] = useState([])
  const [uplineOptionsContracting, setUplineOptionsContracting] = useState([])
  const [splitCommLevels, setSplitCommLevels] = useState([])

  useEffect(() => {
    getUsers()
    getCommisionLevel()
  }, [])

  const getCommisionLevel = async () => {
    try {
      let CL = await CommissionService.search({ pagination: false })
      CL = (CL.models || []).filter(level => level.com_name !== 'Employee')

      // Store commission levels in state
      // Exclude Employee level
      setSplitCommLevels(CL.map((cl, idx) => (idx % 2 === 0 ? [CL[idx], CL[idx + 1]] : false)).filter(n => !!n))
    } catch (error) {
      console.error('Error fetching commission levels', error)
    }
  }

  const getUsers = async () => {
    const users = await UserService.search({
      pagination: false,
      order_by: { u_fname: 'ASC' },
    })

    const onboardingOpts = (users.models || [])
      .filter(user => ![111, 133, 223, 224].includes(user.usertype_id))
      .map(user => ({
        text: user.u_fname + ' ' + user.u_lname,
        value: `${user.id}`,
        ...(CarrierMgmtStore.carrier?.visibility?.onboarding?.upline_ids?.length >= 0 &&
        CarrierMgmtStore.carrier?.visibility?.onboarding?.upline_ids?.includes(`${user.id}`)
          ? { selected: true }
          : {}),
      }))
    setUplineOptionsOnboarding(onboardingOpts)

    const contractingOpts = (users.models || [])
      .filter(user => ![111, 133, 223, 224].includes(user.usertype_id))
      .map(user => ({
        text: user.u_fname + ' ' + user.u_lname,
        value: `${user.id}`,
        ...(CarrierMgmtStore.carrier?.visibility?.contracting?.upline_ids?.length >= 0 &&
        CarrierMgmtStore.carrier?.visibility?.contracting?.upline_ids?.includes(`${user.id}`)
          ? { selected: true }
          : {}),
      }))
    setUplineOptionsContracting(contractingOpts)
  }

  const onChange = event => {
    if (`${CarrierMgmtStore.carrier[event.target.name]}` !== `${event.target.value}`)
      CarrierMgmtStore.carrier[event.target.name] = event.target.value
  }

  const onSubmit = async event => {
    event.preventDefault()
    if (await CarrierMgmtStore.saveCarrier()) {
      toast.success('Carrier updated successfully', {
        position: toast.POSITION.TOP_RIGHT,
      })
    } else {
      toast.error('Failed to save carrier!', {
        position: toast.POSITION.TOP_RIGHT,
      })
    }
  }

  const renderLoadingWheel = () => {
    if (CarrierMgmtStore.getIsLoading('fetch.carrier') || CarrierMgmtStore.getIsLoading('update.carrier'))
      return (
        <span>
          <i className='fa fa-spin fa-spinner' />
        </span>
      )
  }

  return (
    <MDBCard id='CarrierContractingConfigFormComponent'>
      <MDBCardHeader>
        Carrier Contracting Configuration
        {renderLoadingWheel()}
      </MDBCardHeader>
      <MDBCardBody>
        <form noValidate onSubmit={onSubmit}>
          {/* Sending Contacts */}
          <MDBRow className='pb-1'>
            <MDBCol size='12' className='pb-2'>
              <h6 className='alert alert-info'>Sending Carrier Contracts</h6>
            </MDBCol>
            <MDBCol size='12' className='carrier-detail-option'>
              <div>
                <p>Send PDFs as Attachments</p>
                <small>
                  PDFs are linked by default.
                  {CarrierMgmtStore.carrier?.can_email_attachment ? (
                    <>
                      &nbsp;
                      <span className='alert alert-success'>PDFs as Attachment</span>
                    </>
                  ) : (
                    <></>
                  )}
                </small>
              </div>
              <div>
                <CustomSwitch
                  labelLeft={'Off'}
                  labelRight={'On'}
                  name='can_email_attachment'
                  checked={!!CarrierMgmtStore.carrier?.can_email_attachment}
                  onChange={e => {
                    const newValue = e.target.value ? 1 : 0
                    CarrierMgmtStore.carrier.can_email_attachment = newValue
                    if (newValue === 0) CarrierMgmtStore.carrier.merge_email_attachment = 0
                  }}
                />
              </div>
            </MDBCol>
            <MDBCol size='12' className='carrier-detail-option'>
              <div>
                <p>Merge PDF Attachments</p>
                <small>
                  Multiple PDFs are attached by default.
                  {CarrierMgmtStore.carrier?.merge_email_attachment ? (
                    <>
                      &nbsp;
                      <span className='alert alert-success'>Merge PDFs</span>
                    </>
                  ) : (
                    <></>
                  )}
                </small>
              </div>
              <div>
                <CustomSwitch
                  labelLeft={'Off'}
                  labelRight={'On'}
                  name='merge_email_attachment'
                  checked={!!CarrierMgmtStore.carrier?.merge_email_attachment}
                  onChange={e => (CarrierMgmtStore.carrier.merge_email_attachment = e.target.value ? 1 : 0)}
                  disabled={!CarrierMgmtStore.carrier?.can_email_attachment}
                />
              </div>
            </MDBCol>
            <MDBCol size='12' className='carrier-detail-option'>
              <div>
                <p>Carrier Is Automated?</p>
                <small>
                  Carrier contracts are not automated email by default.
                  {CarrierMgmtStore.carrier?.merge_email_attachment ? (
                    <>
                      &nbsp;
                      <span className='alert alert-success'>Automated Delivery</span>
                    </>
                  ) : (
                    <></>
                  )}
                </small>
              </div>
              <div>
                <CustomSwitch
                  labelLeft={'Off'}
                  labelRight={'On'}
                  name='is_automated'
                  checked={`${CarrierMgmtStore.carrier?.is_automated}` === '1'}
                  onChange={e => (CarrierMgmtStore.carrier.is_automated = e.target.value ? 1 : 0)}
                />
              </div>
            </MDBCol>

            {`${CarrierMgmtStore.carrier?.is_automated}` === '1' ? (
              <MDBCol size='12' className='carrier-detail-option use-rows'>
                <div>
                  <p>Contracting Email Address</p>
                  <small>Carrier contracts will be delivered to this email address.</small>
                </div>
                <div>
                  <MDBInput
                    label='Contracting Email Address'
                    type='text'
                    name='contract_email'
                    value={CarrierMgmtStore.carrier?.contract_email || ''}
                    onChange={onChange}
                    autoComplete='off'
                    required
                  />
                </div>
              </MDBCol>
            ) : (
              <></>
            )}
            <MDBCol size='12' className='carrier-detail-option'>
              <div>
                <p>Use Default Links?</p>
                <small>Prioritize the Carrier Contract Link (Templates) OVER Link Banks.</small>
              </div>
              <div>
                <CustomSwitch
                  labelLeft={'Off'}
                  labelRight={'On'}
                  name='use_default_links'
                  checked={`${CarrierMgmtStore.carrier?.use_default_links}` === '1'}
                  onChange={e => (CarrierMgmtStore.carrier.use_default_links = e.target.value ? 1 : 0)}
                />
              </div>
            </MDBCol>
            <MDBCol size='12' className='carrier-detail-option'>
              <div>
                <p>Use Both Links?</p>
                <small>Ensure use of both Carrier Contract Link (Templates) AND Link Banks.</small>
              </div>
              <div>
                <CustomSwitch
                  labelLeft={'Off'}
                  labelRight={'On'}
                  name='use_both_links'
                  checked={`${CarrierMgmtStore.carrier?.use_both_links}` === '1'}
                  onChange={e => (CarrierMgmtStore.carrier.use_both_links = e.target.value ? 1 : 0)}
                />
              </div>
            </MDBCol>
          </MDBRow>

          {/* Visibility: Sales Tracker */}
          <MDBRow className='mt-1 pb-1'>
            <MDBCol size='12' className='pb-2'>
              <h6 className='alert alert-info'>Visibility: Sales Tracker</h6>
            </MDBCol>
            <MDBCol size='12' className='carrier-detail-option'>
              <div>
                <p>Carrier Visibility</p>
                <small>
                  Determines if the Carrier is a selectable option for new Sales Tracker policies.
                  {CarrierMgmtStore.carrier?.visibility?.tracker?.enable ? (
                    <>
                      &nbsp;
                      <span className='alert alert-success'>Sales Tracker Enabled</span>
                    </>
                  ) : (
                    <></>
                  )}
                </small>
              </div>
              <div>
                <CustomSwitch
                  labelLeft={'Off'}
                  labelRight={'On'}
                  name='tracker'
                  checked={!!CarrierMgmtStore.carrier?.visibility?.tracker?.enable}
                  onChange={e => (CarrierMgmtStore.carrier.visibility.tracker.enable = !!e.target.value)}
                />
              </div>
            </MDBCol>
          </MDBRow>

          {/* Visibility: Onboarding: Usertypes */}
          <MDBRow className='mt-1 pt-3'>
            <MDBCol size='12' className='pb-2'>
              <h6 className='alert alert-info'>Visibility: Onboarding</h6>
              <h6 className='alert alert-secondary'>Enable by Usertype</h6>
            </MDBCol>
            <MDBCol size='12' className='carrier-detail-option'>
              <div>
                <p>Carrier Visibility</p>
                <small>
                  Determines if the Carrier is a selectable option while an agent is onboarding.
                  {CarrierMgmtStore.carrier?.visibility?.onboarding?.enable ? (
                    <>
                      &nbsp;
                      <span className='alert alert-success'>Onboarding Enabled</span>
                    </>
                  ) : (
                    <></>
                  )}
                </small>
              </div>
              <div>
                <CustomSwitch
                  labelLeft={'Off'}
                  labelRight={'On'}
                  name='onboarding'
                  checked={!!CarrierMgmtStore.carrier?.visibility?.onboarding?.enable}
                  onChange={e => (CarrierMgmtStore.carrier.visibility.onboarding.enable = !!e.target.value)}
                />
              </div>
            </MDBCol>
            <MDBCol size='12' className='carrier-detail-collapse'>
              <MDBCollapse open={!!CarrierMgmtStore.carrier?.visibility?.onboarding?.enable}>
                <div>
                  <table className='usertype-visibility-table'>
                    <tbody>
                      <tr>
                        <td rowSpan='2'>
                          <p>
                            Enabled
                            <br />
                            Usertypes:
                          </p>
                        </td>
                        <td>Career:</td>
                        <td>
                          <CustomSwitch
                            labelLeft={''}
                            labelRight={''}
                            name='career_agent'
                            checked={!!CarrierMgmtStore.carrier?.visibility?.onboarding?.career_agent}
                            onChange={e =>
                              (CarrierMgmtStore.carrier.visibility.onboarding.career_agent = !!e.target.value)
                            }
                          />
                        </td>
                        <td>Signature:</td>
                        <td>
                          <CustomSwitch
                            labelLeft={''}
                            labelRight={''}
                            name='sig_agent'
                            checked={!!CarrierMgmtStore.carrier?.visibility?.onboarding?.sig_agent}
                            onChange={e =>
                              (CarrierMgmtStore.carrier.visibility.onboarding.sig_agent = !!e.target.value)
                            }
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Affiliate:</td>
                        <td>
                          <CustomSwitch
                            labelLeft={''}
                            labelRight={''}
                            name='affiliate_agent'
                            checked={!!CarrierMgmtStore.carrier?.visibility?.onboarding?.affiliate_agent}
                            onChange={e =>
                              (CarrierMgmtStore.carrier.visibility.onboarding.affiliate_agent = !!e.target.value)
                            }
                          />
                        </td>
                        <td>Associate:</td>
                        <td>
                          <CustomSwitch
                            labelLeft={''}
                            labelRight={''}
                            name='associate_agent'
                            checked={!!CarrierMgmtStore.carrier?.visibility?.onboarding?.associate_agent}
                            onChange={e =>
                              (CarrierMgmtStore.carrier.visibility.onboarding.associate_agent = !!e.target.value)
                            }
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </MDBCollapse>
            </MDBCol>
            <MDBCol size='12' className='carrier-detail-option'>
              <div className='full-width'>
                <p>Disabled Uplines:</p>
                <small>These upline leaders will have the carrier hidden from onboarding.</small>
                <MDBSelect
                  search
                  multiple
                  selectAll
                  data={uplineOptionsOnboarding || []}
                  className='upline-leaders'
                  value={(CarrierMgmtStore.carrier?.visibility?.onboarding?.upline_ids || []).map(String)}
                  placeholder='Choose Upline Leader'
                  onValueChange={value => {
                    const raw = Array.isArray(value) ? value : []
                    const ids = raw.map(item => item?.value).filter(Boolean)
                    if (CarrierMgmtStore.carrier?.visibility?.onboarding)
                      CarrierMgmtStore.carrier.visibility.onboarding.upline_ids = ids.length > 0 ? ids : []
                  }}
                  label='Disabled Uplines'
                />
              </div>
            </MDBCol>
          </MDBRow>

          {/* Visibility: Onboarding: Commission Levels */}
          <MDBRow className='mt-1 pt-3'>
            <MDBCol size='12' className='pb-2'>
              <h6 className='alert alert-secondary'>Hide by Commission Level</h6>
            </MDBCol>
            <MDBCol size='12' className='carrier-detail-option'>
              <div>
                <p>Hide Onboarding Commission Based Visibility</p>
                <small>
                  Determines if the Carrier is hidden while an agent is onboarding.
                  {CarrierMgmtStore.carrier?.visibility?.onboarding?.commission?.enable ? (
                    <>
                      &nbsp;
                      <span className='alert alert-success'>Hidden From Onboarding</span>
                    </>
                  ) : (
                    <></>
                  )}
                </small>
              </div>
              <div>
                <CustomSwitch
                  labelLeft={'Off'}
                  labelRight={'On'}
                  name='onboarding'
                  checked={!!CarrierMgmtStore.carrier?.visibility?.onboarding?.commission?.enable}
                  onChange={e => {
                    if (!CarrierMgmtStore.carrier.visibility.onboarding.commission) {
                      CarrierMgmtStore.carrier.visibility.onboarding.commission = {}
                    }
                    CarrierMgmtStore.carrier.visibility.onboarding.commission.enable = !!e.target.value
                  }}
                />
              </div>
            </MDBCol>
            <MDBCol size='12' className='carrier-detail-collapse'>
              <MDBCollapse open={!!CarrierMgmtStore.carrier?.visibility?.onboarding?.enable}>
                <div>
                  <table className='usertype-visibility-table'>
                    <tbody>
                      {CarrierMgmtStore.carrier?.visibility?.onboarding?.commission?.enable &&
                        splitCommLevels.map((level, idx) => {
                          const [level1, level2] = level
                          return (
                            <tr key={`hide-cl-onboard-${idx}`}>
                              {idx === 0 ? <td rowSpan={`${splitCommLevels.length}`}></td> : <></>}
                              {level1 ? (
                                <>
                                  <td>{level1.com_name}</td>
                                  <td key={`hide-cl-onboard-${level1.id}`}>
                                    <CustomSwitch
                                      labelLeft={''}
                                      labelRight={''}
                                      name={`commission_level_${level1.id}`}
                                      checked={
                                        !!CarrierMgmtStore.carrier?.visibility?.onboarding?.commission?.[level1.id]
                                      }
                                      onChange={() => {
                                        if (!CarrierMgmtStore.carrier.visibility.onboarding.commission) {
                                          CarrierMgmtStore.carrier.visibility.onboarding.commission = {}
                                        }
                                        CarrierMgmtStore.carrier.visibility.onboarding.commission[level1.id] =
                                          !CarrierMgmtStore.carrier.visibility.onboarding.commission[level1.id]
                                      }}
                                    />
                                  </td>
                                </>
                              ) : (
                                <>
                                  <td></td>
                                  <td></td>
                                </>
                              )}
                              {level2 ? (
                                <>
                                  <td>{level2.com_name}</td>
                                  <td>
                                    <CustomSwitch
                                      labelLeft={''}
                                      labelRight={''}
                                      name={`commission_level_${level2.id}`}
                                      checked={
                                        !!CarrierMgmtStore.carrier?.visibility?.onboarding?.commission?.[level2.id]
                                      }
                                      onChange={() => {
                                        if (!CarrierMgmtStore.carrier.visibility.onboarding.commission) {
                                          CarrierMgmtStore.carrier.visibility.onboarding.commission = {}
                                        }
                                        CarrierMgmtStore.carrier.visibility.onboarding.commission[level2.id] =
                                          !CarrierMgmtStore.carrier.visibility.onboarding.commission[level2.id]
                                      }}
                                    />
                                  </td>
                                </>
                              ) : (
                                <>
                                  <td></td>
                                  <td></td>
                                </>
                              )}
                            </tr>
                          )
                        })}
                    </tbody>
                  </table>
                </div>
              </MDBCollapse>
            </MDBCol>
          </MDBRow>

          {/* Visibility: Contracting: Usertypes */}
          <MDBRow className='mt-1 pt-3'>
            <MDBCol size='12' className='pb-2'>
              <h6 className='alert alert-info'>Visibility: Contracting</h6>
              <h6 className='alert alert-secondary'>Enable by Usertype</h6>
            </MDBCol>
            <MDBCol size='12' className='carrier-detail-option'>
              <div>
                <p>Carrier Visibility</p>
                <small>
                  Determines if the Carrier is a selectable option while an agent is contracting.
                  {CarrierMgmtStore.carrier?.visibility?.contracting?.enable ? (
                    <>
                      &nbsp;
                      <span className='alert alert-success'>Contracting Enabled</span>
                    </>
                  ) : (
                    <></>
                  )}
                </small>
              </div>
              <div>
                <CustomSwitch
                  labelLeft={'Off'}
                  labelRight={'On'}
                  name='contracting'
                  checked={!!CarrierMgmtStore.carrier?.visibility?.contracting?.enable}
                  onChange={e => (CarrierMgmtStore.carrier.visibility.contracting.enable = !!e.target.value)}
                />
              </div>
            </MDBCol>
            <MDBCol size='12' className='carrier-detail-collapse'>
              <MDBCollapse open={!!CarrierMgmtStore.carrier?.visibility?.contracting?.enable}>
                <div>
                  <table className='usertype-visibility-table'>
                    <tbody>
                      <tr>
                        <td rowSpan='2'>
                          <p>
                            Enabled
                            <br />
                            Usertypes:
                          </p>
                        </td>
                        <td>Career:</td>
                        <td>
                          <CustomSwitch
                            labelLeft={''}
                            labelRight={''}
                            name='career_agent'
                            checked={!!CarrierMgmtStore.carrier?.visibility?.contracting?.career_agent}
                            onChange={e =>
                              (CarrierMgmtStore.carrier.visibility.contracting.career_agent = !!e.target.value)
                            }
                          />
                        </td>
                        <td>Signature:</td>
                        <td>
                          <CustomSwitch
                            labelLeft={''}
                            labelRight={''}
                            name='sig_agent'
                            checked={!!CarrierMgmtStore.carrier?.visibility?.contracting?.sig_agent}
                            onChange={e =>
                              (CarrierMgmtStore.carrier.visibility.contracting.sig_agent = !!e.target.value)
                            }
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Affiliate:</td>
                        <td>
                          <CustomSwitch
                            labelLeft={''}
                            labelRight={''}
                            name='affiliate_agent'
                            checked={!!CarrierMgmtStore.carrier?.visibility?.contracting?.affiliate_agent}
                            onChange={e =>
                              (CarrierMgmtStore.carrier.visibility.contracting.affiliate_agent = !!e.target.value)
                            }
                          />
                        </td>
                        <td>Associate:</td>
                        <td>
                          <CustomSwitch
                            labelLeft={''}
                            labelRight={''}
                            name='associate_agent'
                            checked={!!CarrierMgmtStore.carrier?.visibility?.contracting?.associate_agent}
                            onChange={e =>
                              (CarrierMgmtStore.carrier.visibility.contracting.associate_agent = !!e.target.value)
                            }
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </MDBCollapse>
            </MDBCol>
            <MDBCol size='12' className='carrier-detail-option'>
              <div className='full-width'>
                <p>Disabled Uplines:</p>
                <small>These upline leaders will have the carrier hidden from contracting.</small>
                <MDBSelect
                  search
                  multiple
                  selectAll
                  data={uplineOptionsContracting || []}
                  className='upline-leaders'
                  value={(CarrierMgmtStore.carrier?.visibility?.contracting?.upline_ids || []).map(String)}
                  placeholder='Choose Upline Leader'
                  onValueChange={value => {
                    const raw = Array.isArray(value) ? value : []
                    const ids = raw.map(item => item?.value).filter(Boolean)
                    if (CarrierMgmtStore.carrier?.visibility?.contracting)
                      CarrierMgmtStore.carrier.visibility.contracting.upline_ids = ids.length > 0 ? ids : []
                  }}
                  label='Disabled Uplines'
                />
              </div>
            </MDBCol>
          </MDBRow>

          {/* Visibility: Contracting: Commission Levels */}
          <MDBRow className='mt-1 pt-3'>
            <MDBCol size='12' className='pb-2'>
              <h6 className='alert alert-secondary'>Hide by Commission Level</h6>
            </MDBCol>
            <MDBCol size='12' className='carrier-detail-option'>
              <div>
                <p>Hide Contracting Commission Based Visibility</p>
                <small>
                  Determines if the Carrier is hidden while an agent is contracting.
                  {CarrierMgmtStore.carrier?.visibility?.contracting?.commission?.enable ? (
                    <>
                      &nbsp;
                      <span className='alert alert-success'>Hidden From Contracting</span>
                    </>
                  ) : (
                    <></>
                  )}
                </small>
              </div>
              <div>
                <CustomSwitch
                  labelLeft={'Off'}
                  labelRight={'On'}
                  name='contracting'
                  checked={!!CarrierMgmtStore.carrier?.visibility?.contracting?.commission?.enable}
                  onChange={e => {
                    if (!CarrierMgmtStore.carrier.visibility.contracting.commission) {
                      CarrierMgmtStore.carrier.visibility.contracting.commission = {}
                    }
                    CarrierMgmtStore.carrier.visibility.contracting.commission.enable = !!e.target.value
                  }}
                />
              </div>
            </MDBCol>
            <MDBCol size='12' className='carrier-detail-collapse'>
              <MDBCollapse open={!!CarrierMgmtStore.carrier?.visibility?.contracting?.enable}>
                <div>
                  <table className='usertype-visibility-table'>
                    <tbody>
                      {CarrierMgmtStore.carrier?.visibility?.contracting?.commission?.enable &&
                        splitCommLevels.map((level, idx) => {
                          const [level1, level2] = level
                          return (
                            <tr key={`hide-cl-onboard-${idx}`}>
                              {idx === 0 ? <td rowSpan={`${splitCommLevels.length}`}></td> : <></>}
                              {level1 ? (
                                <>
                                  <td>{level1.com_name}</td>
                                  <td key={`hide-cl-onboard-${level1.id}`}>
                                    <CustomSwitch
                                      labelLeft={''}
                                      labelRight={''}
                                      name={`commission_level_${level1.id}`}
                                      checked={
                                        !!CarrierMgmtStore.carrier?.visibility?.contracting?.commission?.[level1.id]
                                      }
                                      onChange={() => {
                                        if (!CarrierMgmtStore.carrier.visibility.contracting.commission) {
                                          CarrierMgmtStore.carrier.visibility.contracting.commission = {}
                                        }
                                        CarrierMgmtStore.carrier.visibility.contracting.commission[level1.id] =
                                          !CarrierMgmtStore.carrier.visibility.contracting.commission[level1.id]
                                      }}
                                    />
                                  </td>
                                </>
                              ) : (
                                <>
                                  <td></td>
                                  <td></td>
                                </>
                              )}
                              {level2 ? (
                                <>
                                  <td>{level2.com_name}</td>
                                  <td>
                                    <CustomSwitch
                                      labelLeft={''}
                                      labelRight={''}
                                      name={`commission_level_${level2.id}`}
                                      checked={
                                        !!CarrierMgmtStore.carrier?.visibility?.contracting?.commission?.[level2.id]
                                      }
                                      onChange={() => {
                                        if (!CarrierMgmtStore.carrier.visibility.contracting.commission) {
                                          CarrierMgmtStore.carrier.visibility.contracting.commission = {}
                                        }
                                        CarrierMgmtStore.carrier.visibility.contracting.commission[level2.id] =
                                          !CarrierMgmtStore.carrier.visibility.contracting.commission[level2.id]
                                      }}
                                    />
                                  </td>
                                </>
                              ) : (
                                <>
                                  <td></td>
                                  <td></td>
                                </>
                              )}
                            </tr>
                          )
                        })}
                    </tbody>
                  </table>
                </div>
              </MDBCollapse>
            </MDBCol>
          </MDBRow>

          <MDBRow>
            <MDBCol size='12'>
              <MDBBtn
                color='default'
                className='btn-block'
                type='submit'
                disabled={
                  !CarrierMgmtStore.carrier?.c_name ||
                  (!CarrierMgmtStore.carrier?.contract_email && `${CarrierMgmtStore.carrier?.is_automated}` === '1')
                }
              >
                {CarrierMgmtStore.getIsLoading('update.carrier') ? (
                  <span>
                    Saving...&nbsp;
                    <i className='fa fa-spin fa-spinner' />
                  </span>
                ) : (
                  <>
                    Save Carrier&nbsp;
                    <MDBIcon icon='save' />
                  </>
                )}
              </MDBBtn>
            </MDBCol>
          </MDBRow>
        </form>
      </MDBCardBody>
    </MDBCard>
  )
}

export default observer(CarrierContractingConfigForm)
